<div>
    <app-vwsa-text text="Vehicle Details" weight="bold"></app-vwsa-text>
    <br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-select inputId="jb-vd-model-select" label="Vehicle Model" [options]="modelOptions" [(value)]="selectedModel" (valueChange)="onModelSelected($event)"
                isRequired="true">
            </app-vwsa-select>
        </div>
        <div class="card__list">
            <app-vwsa-select inputId="jb-vd-model-year-select" label="Model Year" [options]="modelYearOptions" [(value)]="selectedModelYear" (valueChange)="onModelYearSelected()"
                isRequired="true">
            </app-vwsa-select>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="odometerReading" label="Odometer Reading" [(value)]="currentOdometer" isRequired="true" (valueChange)="onCurrentOdometerChanged()"
                validationMessage="{{odometerValidationMessage}}">
            </app-vwsa-text-input>
        </div>
    </div>

    <div>
        <p-carousel #carousel [value]="cars" [page]="carouselPageIndex" [numVisible]="numVisible" [numScroll]="numScroll" [responsiveOptions]="responsiveOptions">
            <ng-template let-car pTemplate="item">
                <div class="carousel-item" (click)="carouselItemClicked(car)">
                    <span>{{car}}</span>
                    <br />
                    <img class="carousel-image" src="{{contentImages | ContentImage:car}}" alt="model image">
                </div>
            </ng-template>
        </p-carousel>
    </div>

    <app-vwsa-text weight="bold" text="Current Plan Details"></app-vwsa-text>
    <br />

    <div class="column__list">
        <div class="card__list">
            <app-vwsa-select inputId="customize-plan-type-select" label="Plan Type" [options]="planTypeOptions" [(value)]="selectedPlanType" (valueChange)="onPlanTypeSelected()"
                isRequired="true">
            </app-vwsa-select>
        </div>
        <div class="card__list">
            <div [hidden]="isPlanTypeUnknown">
                <app-vwsa-select inputId="customize-plan-years-select" label="Years" [options]="yearsOptions" [(value)]="selectedYears" (valueChange)="onYearsSelected()"
                    isRequired="true">
                </app-vwsa-select>
            </div>
        </div>
        <div class="card__list">
            <div [hidden]="isPlanTypeUnknown">
                <app-vwsa-select inputId="customize-plan-distance-select" label="Distance" [options]="distanceOptions" [(value)]="selectedDistance"
                    (valueChange)="onDistanceSelected()" isRequired="true">
                </app-vwsa-select>
            </div>
        </div>
    </div>

    <div>
        <span style="font-family:vw-text,Helvetica,Arial,sans-serif;font-size:small;">* Indicates required
            fields</span><br /><br />
        <app-vwsa-button text="Continue" (click)="onContinue()" [disabled]="!canContinue"></app-vwsa-button>
        <br /><br />
        <app-vwsa-button text="Back" (click)="onBack()" variant="secondary"></app-vwsa-button>
    </div>

    <br /><br />
    <app-vwsa-text text="{{contentTexts | ContentText:'Disclaimer'}}" appearance="copy0200" color="secondary">
    </app-vwsa-text>
</div>